module.exports = __webpack_public_path__ + "img/upgrade-rocket.01594b08.svg";